import React, { Component } from 'react';
import { connect } from 'react-redux';
import { find, capitalize, sortBy, cloneDeep } from 'lodash';
import { Link } from 'react-router-dom';

import store from '../../../helpers/store'
import Modal from '../../common/Modal';
import ReactSelect from '../../common/ReactSelect';
import SearchWidget from '../../pages/home/SearchWidget';
import EntitiesList from './EntitiesList';
import { userEntityFiltersActions } from '../../../data/actions/user_entity_filters'

var imprintsSvg = require('!svg-inline-loader!../../../../public/img/labels.svg');
var artistsSvg = require('!svg-inline-loader!../../../../public/img/artists.svg');
var productsSvg = require('!svg-inline-loader!../../../../public/img/products.svg');
var projectsSvg = require('!svg-inline-loader!../../../../public/img/projects.svg');
var tracksSvg = require('!svg-inline-loader!../../../../public/img/tracks.svg');

class EntityFilter extends React.Component {
    pageFilterObjects = [
        { type: "imprints", icon: imprintsSvg },
        { type: "projects", icon: projectsSvg },
        { type: "products", icon: productsSvg },
        { type: "artists", icon: artistsSvg },
        { type: "tracks", icon: tracksSvg },
    ];
    constructor(props){
        super(props);
        let currentFilter = store.get('userEntityFilter') || this.getDefaultFilter();
        let { mainEntityFilter = {} } = props;
        
        for(let key of Object.keys(currentFilter)) {
            currentFilter[key] = currentFilter[key].filter(item=>(mainEntityFilter[key] && mainEntityFilter[key].includes(item.id)));
        }
        
        this.state = {
            currentFilter,
            open: false
        }
        this.setFilterState = this.setFilterState.bind(this);
        this.addToFilter = this.addToFilter.bind(this);
        this.removeFromFilter = this.removeFromFilter.bind(this);
        this.showModal = this.showModal.bind(this);
        this.selectFilter = this.selectFilter.bind(this);
        this.setSearchActive = this.setSearchActive.bind(this);
        this.clear = this.clear.bind(this);
    }

    setSearchActive(searchActive) {
		this.setState({searchActive});
	}
    
    getDefaultFilter(){
        return {imprints: [], artists: [], projects: [], products: [], tracks: [], 
            exclude_imprints: [], exclude_artists: [], exclude_projects: [], exclude_products: [], exclude_tracks: []
        };
    }
    
    componentDidMount(){
        const { dispatch } = this.props;
        dispatch(userEntityFiltersActions.getUserEntityFilters());
    }
    
    showModal(show){
        this.setState({show});
    }
    
    clear() {
        const { onSubmit } = this.props;
        const currentFilter = this.getDefaultFilter();
        this.setFilterState({
            ...currentFilter, 
        }, ()=>onSubmit({...this.state.currentFilter}));
    }

    
    setFilterState(currentFilter, callback) {
        store.set('userEntityFilter', currentFilter);
        this.setState({
            ...this.state,
            currentFilter
        }, callback);
    }
    
    addToFilter(item, include) {
        const { onSubmit } = this.props;
        let { entity: type, id, name_raw: name } = item;
        if(include === false)
            type = 'exclude_' + type;
        
        let entities = this.state.currentFilter[type] || [];
        entities = entities.filter(entity=>entity.id!=id);
        entities.push({id, name});
        
        this.setFilterState({
            ...this.state.currentFilter, 
            [type]: entities
        }, ()=>onSubmit({...this.state.currentFilter}));
    }
    
    selectFilter(newFilter) {
        const { onSubmit } = this.props;
        let currentFilter = cloneDeep(this.state.currentFilter);
        for(let entity of newFilter.entities) {
            const key = (entity.fav_hide == 'hidden' ? 'exclude_' : '') + entity.entity_type;
            currentFilter[key].push({
                id: entity.entity_id,
                name: entity.entity_title
            });
        }
        this.setFilterState({
            ...currentFilter
        }, ()=>onSubmit({...this.state.currentFilter}));
    }

    
    removeFromFilter(id, type) {
        const { onSubmit } = this.props;
        let entities = this.state.currentFilter[type];
        entities = entities.filter(entity=>entity.id!=id);
        this.setFilterState({
            ...this.state.currentFilter, 
            [type]: entities
        }, ()=>onSubmit({...this.state.currentFilter}));        
    }

    renderFilterEntities(entities) {
        const include = {};
        const exclude = {};

        Object.keys(entities).forEach(key => {
            if (key.startsWith('exclude_')) {
                exclude[key] = entities[key];
            } else {
                include[key] = entities[key];
            }
        });

        const hasInclude = Object.values(include).some(arr => arr.length);
        const hasExclude = Object.values(exclude).some(arr => arr.length);

        return (
            <div className="filter-search-list">
                {hasInclude && (
                    <React.Fragment>
                        <h5 className="filter-search-list-title">Inclusions</h5>
                        {Object.keys(include).map(type =>
                            include[type].length ? (
                                <EntitiesList
                                    key={type}
                                    pageFilterObjects={this.pageFilterObjects}
                                    entities={include[type]}
                                    type={type}
                                    onDelete={this.removeFromFilter}
                                />
                            ) : null
                        )}
                    </React.Fragment>
                )}

                {hasExclude && (
                    <React.Fragment>
                        <h5 className="filter-search-list-title">Exclusions</h5>
                        {Object.keys(exclude).map(type =>
                            exclude[type].length ? (
                                <EntitiesList
                                    key={type}
                                    pageFilterObjects={this.pageFilterObjects}
                                    entities={exclude[type]}
                                    type={type}
                                    onDelete={this.removeFromFilter}
                                />
                            ) : null
                        )}
                    </React.Fragment>
                )}

            </div>
        );
    }
        
    renderFilterSelect() {
        const { currentFilter } = this.state,
            { loading, filters = [] } = this.props.userEntityFilters,
            filterOptions = sortBy(filters, f=>String(f.caption).toLowerCase()).map(filter=>({label: filter.caption, value: filter})),
            selectedFilter = currentFilter ? find(filterOptions, option=>option.value.id == currentFilter.id) : null;
            
        return <ReactSelect
            loading
            value={selectedFilter}
            options={filterOptions}
            onChange={({value})=>this.selectFilter(value)}
            isLoading={loading}
            isSearchable={true}
            onFocus={()=>this.setSearchActive(true)}
            placeholder="Saved Filters"
            className="entity-filter-select"
        />
    }


    
    render() {
        const filter = this.state.currentFilter;
        const { onSubmit } = this.props;
        
        let currentlySelectedItems = [];
        for(let entity of Object.keys(filter)) {
            let fav_hide = 'favorite', entity_type = entity;

            if(entity.startsWith('exclude_')) {
                fav_hide = 'hidden';
                entity_type = entity.replace('exclude_', '');
                
            }
            let items = filter[entity].map(item=>({
                entity_id: item.id,
                entity_title: item.name,
                entity_type,
                fav_hide
            }));
            currentlySelectedItems = currentlySelectedItems.concat(items);
        }
        return <div>
                
                {/*<Modal show={this.state.show}  
                    title="Entity Filter"
                    submitTitle="Apply"
                    handleSubmit={()=>{onSubmit(filter); this.showModal(false);}} 
                    handleClose={()=>this.showModal(false)}
                >*/}
                    <div className="user-entity-filter main-filter-entity"> 
                        <div>
                            <SearchWidget searchResult={this.addToFilter} mode="playlist" searchItemMode="include_exclude" />
                            {this.renderFilterSelect()}
                        </div>
                        <div className='filter-entities-search-result'>
                            {this.renderFilterEntities(filter)}
                            <div className="entity-filter-actions">
                                <Link to="/user/entities-filter" className='manage-saved-filters default-btn default-btn--small'>Manage Saved Filters</Link>
                                {currentlySelectedItems.length > 0 && 
                                    <React.Fragment>
                                    <Link className="new-filter-link default-btn default-btn--small" to={{pathname:"/user/entities-filter/new", state:{defaultEntities: currentlySelectedItems}}}>Save as New Filter</Link>
                                    <a onClick={this.clear} className="remove-filter-link">Clear Selected</a>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                {/*</Modal>
                <a onClick={()=>this.showModal(true)}>Filter</a>
                */}
                {/*
                <a onClick={()=>onSubmit(filter)} className="btn btn-primary">Set</a>
                */}
            </div>;
    }
}

function mapStateToProps(state) {
    return {
        filter: state.filter,
        userEntityFilters: state.userEntityFilters
    } 
}
export default connect(mapStateToProps)(EntityFilter);